import Decimal from 'decimal.js-light';
import { WidgetType } from '../../widgets/Widget';
import { FieldDatatype } from '../datatype/Datatype';
import { IReferencePath } from './IReferencePath';
import { VirtualReferenceType } from './virtual/VirtualReferenceType';

export enum ReferenceType {
  Widget = 'widget',
  VirtualColumn = 'virtualColumn',
  Session = 'session', // Valore di sessione
  Sample = 'sample', // Valore del campione
  Register = 'register', // Valore di anagrafica
  SemanticFields = 'semanticFields', // Campo Semantico
  DossierSemanticFields = 'dossierSemanticFields', // Campo Semantico di una pratica
  Metadata = 'metadata', // Metadati della submission (Fase, Stato Integrazione, ...)
}

/**
 * Riferimento, in un'espressione, ad un valore di un campo di
 * un altro Widget.
 *
 * Un riferimento è sempre relativo al percorso del Widget che lo utilizza,
 * ad esempio se mi trovo in una lista ripetibile, il `path` a un elemento
 * nel padre sarà sempre relativo a quello.
 *
 * /!\ Questo insieme di informazioni è _dinamico_ e calcolato a runtime,
 * dovrebbe essere aggiornao all'interno della configurazione.
 */
export interface IReference {
  type: ReferenceType;
  /**
   * Se si fa riferimento a un widget, salvo anche il widgetType
   */
  widgetType?: WidgetType | null;

  /**
   * Se siamo in un campo virtuale, è possibile che il campo a cui si fa
   * riferimento sia la colonna stessa.
   */
  virtualType?: VirtualReferenceType | null;

  /**
   * Percorso relativo tra il Widget "corrente" e il Widget a cui si
   * fa riferimento
   */
  path: IReferencePath;
  /**
   * ID del Widget a cui si riferisce.
   */
  id: string;
  /**
   * Codice del Widget a cui si riferisce.
   * Potenzialmente potrebbe cambiare, dobbiamo assicurarci che resti in
   * sincronia con il Widget oppure non utilizzalo e rifersi solo per ID.
   */
  code: string;
  /**
   * Label del Widget. La riportiamo qui come dato denormalizzato, dovremmo
   * cercare di evitare di usarlo a runtime per evitare che sia "desincronizzato"
   * rispetto al Widget.
   */
  label: string;
  field: FieldDatatype;

  /**
   * Titolo del gruppo in cui si trova la reference all'interno della select.
   * Utile per organizzare le reference in gruppi, così da migliorare la UI.
   * Se non presente, farà parte del gruppo "Riferimenti".
   */
  group?: string | null;
}

export type IReferenceValue =
  | number
  | string
  | boolean
  | Date
  | null
  | string[]
  | number[]
  | Decimal
  | IReferenceObjectValue[];

export type IReferenceObjectValue = Record<string, IReferenceValue>;
export type IReferencePlainValue = Exclude<
  IReferenceValue,
  IReferenceObjectValue[]
>;

export interface IReferenceId {
  id: string;
}
